import React from 'react';
import { NavLink } from "react-router-dom";

export type UploadSuccessProps = {
    recordsFound: number;
    onFileRemoved: any;
};

const UploadSuccess = (props: UploadSuccessProps) => (
    <div className="container" style={{ width: "50%" }}>
        <div className="row" style={{ height: "450px" }}>
            <div className="col file-upload-container align-self-center" style={{ border: "1px solid #c1bbbb" }}>
                <div className="uploaded-no-errors-container">
                    <i className="fa fa-check uploaded-no-errors-check"></i>
                </div>
                <div className="uploaded-success-info uploaded-no-errors-container">
                    <span>{props.recordsFound} Records Successfully Imported</span>
                </div>
                <div className="uploaded-no-errors-container">
                    <NavLink to="/settings/customers/" className="btn btn-primary" style={{ color: "white" }}>
                        BACK TO CUSTOMERS
                    </NavLink>
                </div>
                <div className="uploaded-no-errors-container">
                    <button className="link-button" onClick={props.onFileRemoved} style={{ fontSize: "12px" }}>
                        IMPORT ANOTHER FILE
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export default UploadSuccess;
